(()=>{
  const KEY='morgan:welcome-first-order:d216:dismissed-at';
  const WEEK=7*24*60*60*1000;
  const read=()=>{try{return Number(localStorage.getItem(KEY)||0);}catch{return 0;}};
  const remember=()=>{try{localStorage.setItem(KEY,String(Date.now()));}catch{/* Offer still works without browser storage. */}};
  const init=()=>document.querySelectorAll('[data-morgan-welcome]').forEach(root=>{
    if(root.dataset.welcomeReady)return;
    root.dataset.welcomeReady='true';
    const dialog=root.querySelector('dialog');
    const teaser=root.querySelector('[data-welcome-teaser]');
    if(!dialog||typeof dialog.showModal!=='function')return;
    let previousFocus=null;
    const anotherModal=()=>[...document.querySelectorAll('dialog[open],[aria-modal="true"]')].some(el=>el!==dialog&&el.getClientRects().length);
    const open=trigger=>{
      if(!root.isConnected||dialog.open||document.hidden||anotherModal())return false;
      previousFocus=trigger instanceof HTMLElement?trigger:document.activeElement;
      if(teaser)teaser.hidden=true;
      dialog.showModal();
      dialog.querySelector('[data-welcome-close]')?.focus({preventScroll:true});
      return true;
    };
    root.querySelectorAll('[data-welcome-close]').forEach(button=>button.addEventListener('click',()=>dialog.close()));
    const form=dialog.querySelector('form');
    const revealNativeVerification=()=>{
      if(dialog.open&&form?.matches(':valid'))dialog.close();
    };
    form?.addEventListener('click',event=>{
      if(event.target instanceof Element&&event.target.closest('button[type="submit"]'))revealNativeVerification();
    },true);
    form?.addEventListener('submit',revealNativeVerification,true);
    root.querySelector('[data-welcome-expand]')?.addEventListener('click',event=>open(event.currentTarget));
    root.querySelector('[data-welcome-dismiss]')?.addEventListener('click',()=>{if(teaser)teaser.hidden=true;remember();});
    dialog.addEventListener('click',event=>{
      if(event.target!==dialog)return;
      const r=dialog.getBoundingClientRect();
      if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();
    });
    dialog.addEventListener('close',()=>{
      remember();
      if(teaser&&previousFocus instanceof Element&&teaser.contains(previousFocus))teaser.hidden=false;
      if(previousFocus instanceof HTMLElement&&previousFocus.isConnected)previousFocus.focus({preventScroll:true});
    });
    document.addEventListener('click',event=>{
      const link=event.target instanceof Element?event.target.closest('[data-morgan-welcome-open]'):null;
      if(link&&!event.metaKey&&!event.ctrlKey&&!event.shiftKey&&!event.altKey&&open(link))event.preventDefault();
    });
    if(root.dataset.editor==='true'||Date.now()-read()<WEEK)return;
    const deadline=Date.now()+30000;
    const attempt=()=>{
      if(!root.isConnected)return;
      const editing=document.activeElement?.matches('input,textarea,select,[contenteditable="true"]');
      if(!editing&&!document.hidden&&!anotherModal()&&open(null))return;
      if(Date.now()<deadline)setTimeout(attempt,1500);
    };
    setTimeout(attempt,Math.max(5,Math.min(30,Number(root.dataset.delay)||8))*1000);
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();
